/**
 * Склонение слов в зависимости от числа
 * @param value - число
 * @param words - массив слов [1 предмет, 2 предмета, 5 предметов]
 * @returns склоненное слово
 */
export const plural = (value: number, words: [string, string, string]): string => {
  const absValue = Math.abs(value) % 100;
  const num = absValue % 10;

  if (absValue > 10 && absValue < 20) {
    return words[2];
  }

  if (num > 1 && num < 5) {
    return words[1];
  }

  if (num === 1) {
    return words[0];
  }

  return words[2];
};

/**
 * Преобразует первую букву строки в заглавную
 * @param string - строка для преобразования
 * @returns преобразованная строка
 */
export const firstLetterToUpperCase = (string: string): string | undefined => {
  if (!string) {
    return;
  }

  return string[0]!.toUpperCase() + string.slice(1);
};

/** Ключ сравнения без регистра и ё; длина строки не меняется, поэтому срез по ключу совпадает со срезом текста. */
export const foldCaseAndYo = (text: string): string => text.toLowerCase().replaceAll('ё', 'е');
